import * as actionsType from './Trade.ActionType'

const initState = {
  data: null,
  trade: null,
  loading: false,
  error: null,

  updated: false,
  deleted: false,
  created: false,
}

export default function tradeReducer(state = initState, action) {
  const actions = {
    [actionsType.GET_TRADES.REQUEST]: {
      ...state,
      loading: true,
      error: null
    },
    [actionsType.GET_TRADES.SUCCESS]: {
      ...state,
      loading: false,
      data: action.data
    },
    [actionsType.GET_TRADES.FAILURE]: {
      ...state,
      loading: false,
      error: action.error
    },
    [actionsType.GET_TRADE.REQUEST]: {
      ...state,
      loading: true,
      error: null
    },
    [actionsType.GET_TRADE.SUCCESS]: {
      ...state,
      loading: false,
      trade: action.data
    },
    [actionsType.GET_TRADE.FAILURE]: {
      ...state,
      loading: false,
      error: action.error
    },
    [actionsType.UPDATE_TRADE.REQUEST]: {
      ...state,
      loading: true,
      error: null
    },
    [actionsType.UPDATE_TRADE.SUCCESS]: {
      ...state,
      loading: false,
      updated: true
    },
    [actionsType.UPDATE_TRADE.FAILURE]: {
      ...state,
      loading: false,
      error: action.error
    },
    [actionsType.DELETE_TRADE.REQUEST]: {
      ...state,
      loading: true,
      error: null,
    },
    [actionsType.DELETE_TRADE.SUCCESS]: {
      ...state,
      loading: false,
      deleted: true,
    },
    [actionsType.DELETE_TRADE.FAILURE]: {
      ...state,
      loading: false,
      error: action.error,
    },
    [actionsType.CREATE_TRADE.REQUEST]: {
      ...state,
      loading: true,
      error: null,
    },
    [actionsType.CREATE_TRADE.SUCCESS]: {
      ...state,
      loading: false,
      created: true,
    },
    [actionsType.CREATE_TRADE.FAILURE]: {
      ...state,
      loading: false,
      error: action.error,
    },
    [actionsType.SEARCH_TRADE.REQUEST]: {
      ...state,
      loading: true,
      error: null
    },
    [actionsType.SEARCH_TRADE.SUCCESS]: {
      ...state,
      loading: false,
      data: action.data
    },
    [actionsType.SEARCH_TRADE.FAILURE]: {
      ...state,
      loading: false,
      error: action.error
    },
  }

  return actions[action.type] || state
}